<template>
  <mf-loading-dialog :loading="loading">
    <edit
      v-if="editable"
      :campaign="campaign"
      :offer-schedule="offerSchedule"
      :is-offer-schedule-permission-active="isOfferSchedulePermissionActive"
      :is-offer-schedule-personalized="isOfferSchedulePersonalized"
    />
  </mf-loading-dialog>
</template>

<script>
// import cloneDeep from 'lodash/cloneDeep'
// import { QUERY_GET_EMAIL_CAMPAIGN_BY_ID } from '@/modules/campanhas/campanhas-email/graphql'
import offerScheduleCampaign from '@/modules/campanhas/views/mixins/offer-schedule-campaign.js'
import { highlightOffer } from '../../mixins/highlight-offer'
import { mapGetters } from 'vuex'

export default {
  name: 'EmailCampaign',
  components: {
    Edit: () => import('./Edit.vue'),
  },
  mixins: [offerScheduleCampaign, highlightOffer],
  data: () => ({
    campaignId: '',
    loading: false,
    campaign: {
      title: '',
      description: '',
      initial_date: '',
      final_date: '',
      products: [],
      productsGroups: [],
      segments: [],
      status: 'DRAFT',
      template_id: '',
      frequency: {
        type: 'ONETIME',
        interval: 0,
      },
      image_url: '',
      message: {
        send_date: '',
        send_time: '',
        title: '',
        text: '',
        inner_message_title: '',
        inner_message_text: '',
        innerMessage: false,
      },
      offers_schedule_id: '',
    },
  }),
  computed: {
    ...mapGetters(['units', 'tagList']),
    highlight: {
      set(value) {
        this.setHighlightObject(value)
      },
      get() {
        return this.highlightOffer
      },
    },
    editable() {
      return ['DRAFT', 'SCHEDULED', 'ACTIVE'].includes(this.campaign.status)
    },
    newHightlight() {
      let path = this.$router.currentRoute.fullPath
      return path.includes('novo')
    },
  },
  apollo: {},
  watch: {
    $route(route) {
      if (route.params?.id?.length !== 24 && route.query?.quick_action) {
        // Reset the data
        Object.assign(this.$data, this.$options.data.apply(this))
      }
    },
  },
  created() {
    this.$store.dispatch('getStates', ['fetchUnits'])
  },
  async mounted() {
    this.$store.commit('RESET_HIGHLIGHT_DATA')
    this.campaignId = this.$route.params.id
    if (this.campaignId?.length !== 24) this.campaignId = ''
    if (!this.newHightlight) {
      this.loading = true
      try {
        await this.getHighlight({ highlightedOfferId: this.campaignId })
        this.offerSchedule = this.highlightOfferSchedule
          ? {
              _id: this.highlightOfferSchedule.id,
              name: this.highlightOfferSchedule.name,
              description: this.highlightOfferSchedule.description,
              end_date: this.highlightOfferSchedule.endDate,
              start_date: this.highlightOfferSchedule.startDate,
            }
          : {}
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar dados no servidor.', snackbarColor: 'error' })
      }
      this.$set(
        this.highlight,
        'units',
        this.highlight.units.map((unit) => unit.id_erp)
      )
      this.loading = false
    }
  },
}
</script>
